/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCheckInSalesRepDeviceResponseFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, serializeCheckInSalesRepDeviceRequest, serializeCheckInSalesRepDeviceResponse, type CheckInSalesRepDeviceRequest, type CheckInSalesRepDeviceResponse, type ErrorResponse, type InternalErrorResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/salesreps/devices/checkin
 */
export interface CheckinRequestBuilder extends BaseRequestBuilder<CheckinRequestBuilder> {
    /**
     * Records the calling sales rep's device, app version and last-login date, stamping the check-in time. One document per device — repeat check-ins update it in place.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CheckInSalesRepDeviceResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {ErrorResponse} error when the service returns a 429 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: CheckInSalesRepDeviceRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<CheckInSalesRepDeviceResponse | undefined>;
    /**
     * Records the calling sales rep's device, app version and last-login date, stamping the check-in time. One document per device — repeat check-ins update it in place.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: CheckInSalesRepDeviceRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const CheckinRequestBuilderUriTemplate = "{+baseurl}/api/salesreps/devices/checkin";
/**
 * Metadata for all the requests in the request builder.
 */
export const CheckinRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: CheckinRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            429: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCheckInSalesRepDeviceResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCheckInSalesRepDeviceRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
